import { useTranslation } from "react-i18next";
import EventGallery from "../../components/EventGallery/EventGallery";
import HeroSlider from "../../components/HeroSlider/HeroSlider";
import galleryEvents from "../../content/gallery";
import { formatDisplayDate, getLocale } from "../../utils/content";
import img1 from "../../assets/HeroSlider/hero1.jpg";
import img4 from "../../assets/HeroSlider/hero4.jpg";
import img8 from "../../assets/HeroSlider/hero8.jpg";
import styles from "./Gallery.module.scss";

const images = [img8, img4, img1];

export default function Gallery() {
  const { t, i18n } = useTranslation();
  const locale = getLocale(i18n.language);

  return (
    <section className={styles.gallery}>
      <HeroSlider label={t("hero_slider_gallery")} images={images} />

      <div className={styles.container}>
        <div className={styles.heading}>
          <h1>{t("gallery_title")}</h1>
          <p>{t("gallery_intro")}</p>
        </div>

        <div className={styles.events}>
          {galleryEvents.map((event) => (
            <EventGallery
              key={event.id}
              event={event}
              locale={locale}
              t={t}
              fallbackDate={formatDisplayDate(event.date, locale)}
            />
          ))}
        </div>

        {/*<div className={styles.noteCard}>
          <p>{t("gallery_upload_note")}</p>
        </div>*/}
      </div>
    </section>
  );
}
